module.exports = __webpack_public_path__ + "img/support.65f3e164.svg";